import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, nextTick, onBeforeMount, reactive } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRouter } from "vue-router";
import Pagination from "@/components/Pagination/index.vue";
import "swiper/swiper.scss";
import Swiper from "swiper";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  name: "Field",
  components: {
    Head: Head,
    Pagination: Pagination
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var baseUrl = process.env.VUE_APP_BASE_URL; // 获取个人资料

    var Data = reactive({
      time: [{
        num: 1,
        color: "#e8e8e8"
      }],
      hour: 0,
      searchContent: "",
      list: [],
      total: 0,
      value1: [],
      search: {
        startTime: "",
        endTime: "",
        pageIndex: 1,
        pageSize: 10,
        fieldName: ""
      },
      timeData: {
        fieldId: 0,
        time: getTime()
      },
      num: [],
      timeItems: [],
      swiperNum: []
    }); //计数

    for (var i = 0; i < 49; i++) {
      Data.num.push(i);
    }

    Data.num.map(function (i) {
      var val = i / 2 < 10 ? "0" + Math.floor(i / 2) : Math.floor(i / 2),
          val1 = Math.ceil(i % 2) == 1 ? "30" : "00";
      Data.timeItems.push(val + ":" + val1);
    });

    function getTime() {
      var date = new Date(),
          year = date.getFullYear(),
          month = date.getMonth() + 1,
          day = date.getDate();
      var months = month < 10 ? "0" + month : month;
      var timer = year + "-" + months + "-" + day;
      return timer;
    }

    var changPage = function changPage(val) {
      Data.search.pageIndex = val;
    };

    function getDetail() {
      return _getDetail.apply(this, arguments);
    } //筛选


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti, data, total;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Data.list = [];
                _context2.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["FieldPcList"](Data.search);

              case 3:
                _yield$globalProperti = _context2.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                Data.list = data;
                Data.total = total;
                Data.timeData.fieldId = data;
                Data.list.forEach(function (item) {
                  if (!item.list) {
                    item.list = [];
                  }
                });
                Data.search.startTime = '';
                Data.search.endTime = '';
                newData();
                Data.timeItems.forEach(function (item, index) {
                  if (item < delData(new Date().getHours(), new Date().getMinutes())) {
                    Data.swiperNum.push(index);
                  }
                });
                nextTick(function () {
                  new Swiper(".swiper-container", {
                    autoHeight: true,
                    slidesPerView: "auto",
                    observer: true,
                    initialSlide: Data.swiperNum[Data.swiperNum.length - 15]
                  });
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getDetail.apply(this, arguments);
    }

    function handleChange(val) {
      var p = function p(s) {
        return s < 10 ? "0" + s : s;
      };

      var startDate = new Date().getFullYear() + "-" + p(new Date().getMonth() + 1) + "-" + p(new Date().getDate()) + " " + val[0] + ":00";
      var endDate = new Date().getFullYear() + "-" + p(new Date().getMonth() + 1) + "-" + p(new Date().getDate()) + " " + val[1] + ":00";
      Data.search.startTime = startDate;
      Data.search.endTime = endDate;
      getDetail();
    } //详情


    var detail = function detail(id) {
      router.push({
        name: "FieldDetail",
        query: {
          fieldId: id
        }
      });
    }; //立即预约


    var handleClick = function handleClick(id, delFlag) {
      if (delFlag == 0) {
        router.push({
          name: "FieldAppointment",
          query: {
            field: id
          }
        });
      } else if (delFlag == 1) {
        ElMessage.warning("该场地已暂停使用");
      } else {
        ElMessage.warning("该场地正在维修中");
      }
    }; //搜索


    function searchList() {
      return _searchList.apply(this, arguments);
    } //我的预约


    function _searchList() {
      _searchList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getDetail();

              case 2:
                new Swiper(".swiper-container", {
                  autoHeight: true,
                  slidesPerView: "auto",
                  observer: true
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _searchList.apply(this, arguments);
    }

    function myappointment() {
      router.push("/personal/MyFieldIndex");
    } //处理时间


    function delData(hourFun, minuteFun) {
      if (hourFun < 10) {
        return String("0" + hourFun + ":" + minuteFun);
      } else if (minuteFun < 10) {
        return String(hourFun + ":" + "0" + minuteFun);
      } else if (hourFun < 10 && minuteFun < 10) {
        return String("0" + hourFun + ":" + "0" + minuteFun);
      } else {
        return String(hourFun + ":" + minuteFun);
      }
    } //获取时间


    function newData() {
      //向数组中写入数据
      var date = new Date();
      Data.hour = date.getHours();
      var minute = date.getMinutes();
      Data.list.forEach(function (item) {
        if (item.list.length == 0) {
          for (var i = 0; i < 49; i++) {
            var val = i / 2 < 10 ? "0" + Math.floor(i / 2) : Math.floor(i / 2),
                val1 = Math.ceil(i % 2) == 1 ? "30" : "00";

            if (i % 2 == 0) {
              item.list.push({
                num: i / 2,
                color: "",
                time: val + ":" + val1
              });
            } else {
              item.list.push({
                time: val + ":" + val1,
                color: ""
              });
            }
          }

          Data.list.forEach(function (item) {
            item.list.forEach(function (item1) {
              if (item1.time < delData(Data.hour, minute)) {
                item1.color = "#e8e8e8";
              }
            });
          });
        } else {
          var arr = [];
          if (item.list instanceof Array) item.list.forEach(function (item1, index) {
            var val = index / 2 < 10 ? "0" + Math.floor(index / 2) : Math.floor(index / 2),
                val1 = Math.ceil(index % 2) == 1 ? "30" : "00";
            item1.color = "#e8e8e8", item1.time = val + ":" + val1;

            if (index % 2 == 0) {
              item1.num = index / 2;
            }

            Data.timeItems.forEach(function (items, indexs) {
              if (items == item1.startTime.slice(11, 16)) {
                arr.push(indexs);
              }

              if (items == item1.endTime.slice(11, 16)) {
                arr.push(indexs);
              }
            });
          });

          for (var j = item.list.length; j < 49; j++) {
            var _val = j / 2 < 10 ? "0" + Math.floor(j / 2) : Math.floor(j / 2),
                _val2 = Math.ceil(j % 2) == 1 ? "30" : "00";

            if (j % 2 == 0) {
              item.list.push({
                num: j / 2,
                color: "",
                time: _val + ":" + _val2
              });
            } else {
              item.list.push({
                time: _val + ":" + _val2,
                color: ""
              });
            }
          }

          Data.list.forEach(function (item) {
            item.list.forEach(function (item1) {
              if (item1.time < delData(Data.hour, minute)) {
                item1.color = "#e8e8e8";
              }
            });
          });

          if (arr instanceof Array) {
            var arrIndex = [];
            arr.forEach(function (item, index) {
              if (index % 2 == 0) {
                arrIndex.push({
                  start: index,
                  end: index + 1
                });
              }
            });
            arrIndex.forEach(function (item3) {
              item.list.slice(arr[item3.start], arr[item3.end]).forEach(function (item4) {
                item4.color = "#e8e8e8";
              });
            });
          }
        }
      });
    }

    onBeforeMount( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getDetail();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return {
      getDetail: getDetail,
      Data: Data,
      detail: detail,
      handleClick: handleClick,
      searchList: searchList,
      changPage: changPage,
      baseUrl: baseUrl,
      myappointment: myappointment,
      handleChange: handleChange
    };
  }
});